import { GTMEvent } from '../GTM'
import { formatPrice } from '@corratech/pylot-seo'
import { itemHasKeys } from '@corratech/pylot-utils'
import { NextRouter } from 'next/router'

type GTMCartItemData = {
    id: string
    name: string
    price: number
    quantity: number
    currencyCode: string
    category?: string
    variant?: string
    brand?: string
}

const mandatoryCartItemProps = [
    'id',
    'name',
    'price',
    'quantity',
    'currencyCode'
]

const isValidGTMCartItems = (items: unknown): items is GTMCartItemData[] => {
    if (!Array.isArray(items)) {
        return false
    }
    let result = true
    for (const item of items) {
        if (item && !itemHasKeys(item, mandatoryCartItemProps)) {
            result = false
        }
    }
    return result
}

const EVENT_NAME_MAP = {
    add: 'addToCart',
    remove: 'removeFromCart'
}

export const formatCartGTMEvent = (
    data: Record<string, unknown>,
    event: 'add' | 'remove',
    router: NextRouter
): GTMEvent => {
    const { updatedItems, productsDetails } = data

    if (!isValidGTMCartItems(updatedItems)) {
        console.info(`Invalid GTM ${event} cart item data`)
        return { event: '' }
    }

    const mappedUpdatedItems = updatedItems.map((item) => {
        return { ...item, price: formatPrice(Number(item.price)) }
    })
    const currencyCode = updatedItems[0].currencyCode

    const products =
        productsDetails && Array.isArray(productsDetails) ? productsDetails : []
    // Reorder cart items
    products.reverse()

    return {
        event: EVENT_NAME_MAP[event],
        ecommerce: {
            currencyCode,
            [event]: {
                products: mappedUpdatedItems
            }
        },
        cartContents: {
            currencyCode,
            products
        },
        _clear: true
    }
}

export const pushAddToCart = (
    data: Record<string, unknown>,
    router: NextRouter
): GTMEvent => {
    return formatCartGTMEvent(data, 'add', router)
}

export const pushRemoveFromCart = (
    data: Record<string, unknown>,
    router: NextRouter
): GTMEvent => {
    return formatCartGTMEvent(data, 'remove', router)
}
